import React from 'react'
import TeamLogo from 'components/shared/icons/TeamLogo'
import HodlockerIcon from 'components/shared/icons/HodlockerIcon'
import TwetchIcon from 'components/shared/icons/TwetchIcon'
import { buildHoverTooltipAnchorProps } from 'components/shared/tooltipContract'
import { isMobile } from 'lib/device'

export default function TeamIcon(props) {
    const {
        team,
        contextStyles,
        hoverStyles,
        selectedStyles,
        initialStyles,
        borderStyles,
        quest,
        tip,
        onClick,
    } = props

    const handleClick = ev => {
        if (onClick) onClick(team.id, ev)
    }

    const isHodlocker = team.id === gon.HODLOCKER_TEAM_ID
    const isTwetch = team.id === gon.TWETCH_TEAM_ID
    const tooltipProps = buildHoverTooltipAnchorProps(
        { content: tip || `${team.name} Group` },
        { touchLayout: isMobile },
    )

    return (
        <div onClick={handleClick} {...tooltipProps}>
            {isHodlocker ? (
                <HodlockerIcon
                    contextStyles={contextStyles}
                    hoverStyles={hoverStyles}
                    selectedStyles={selectedStyles}
                    initialStyles={initialStyles}
                />
            ) : isTwetch ? (
                <TwetchIcon
                    contextStyles={contextStyles}
                    hoverStyles={hoverStyles}
                    selectedStyles={selectedStyles}
                />
            ) : (
                <TeamLogo
                    team={team}
                    contextStyles={contextStyles}
                    hoverStyles={hoverStyles}
                    selectedStyles={selectedStyles}
                    initialStyles={initialStyles}
                    borderStyles={borderStyles}
                    quest={quest}
                />
            )}
        </div>
    )
}
